import React from 'react';
import DonutChart from 'components/pure/charts/DonutChart';
import theme from 'styles/theme';
import {List} from 'immutable';

/* Like a progress bar but in circular form */
// TODO I didn't notice CircularScore that already exists.
// It's a pretty similar component, those should probably be merged toegether
export default class CircularProgress extends React.PureComponent {
  static defaultProps = {
    color: theme.palette.flamingo,
  };

  render() {
    const {percentage, color, ...otherProps} = this.props;
    const pieData = List([percentage, 100 - percentage]).map((percent, i) => ({
      id: i,
      value: percent,
      selected: percent === percentage,
    }));
    return (
      <DonutChart
        data={pieData}
        className="circular-progress"
        sorted={false}
        thickness={10}
        padAngle={0}
        height={50}
        width={50}
        color={color}
        {...otherProps}
      />
    );
  }
}
